module.exports = __webpack_public_path__ + "static/img/Andrew-Johns.8aee2d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Andrew-Johns.jpg
// module id = fBwl
// module chunks = 0